import { Link } from "react-router-dom";
import type { Film } from "@/types";

interface HotFilmsProps {
  films: Film[];
}

export default function HotFilms({ films }: HotFilmsProps) {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            热门影视推荐
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">
            依据播放热度综合排序（演示数据）
          </p>
        </div>
        <Link
          to="/category?sort=hot"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          更多热门
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {films.map((film, index) => (
          <Link
            key={film.id}
            to={`/detail/${film.id}`}
            className="group flex items-center gap-4 p-3 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-300 transition-colors duration-300 cursor-pointer"
          >
            <span className="w-9 shrink-0 font-heading font-bold text-2xl text-center text-accent-500 group-hover:text-accent-600">
              {index + 1}
            </span>
            <div className="w-14 h-20 shrink-0 rounded-md overflow-hidden bg-secondary-200">
              <img
                src={film.poster}
                alt={`${film.title}海报`}
                title={`${film.title}影视作品`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                {film.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 truncate">
                {film.type} · {film.region} · {film.year}
              </p>
              <p className="mt-1.5 flex items-center gap-1 text-xs text-accent-700">
                <i className="ri-fire-line"></i>
                热度 {film.heat.toLocaleString()}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}